/**
 * The natural (unzoomed) coordinate space every annotation surface
 * shares. Shape coordinates are stored in this space; consumers scale
 * their viewport, never the coordinates.
 *
 * Its own module, free of DOM types, so code with no canvas (the API
 * building a widget pin's marker, TOADO-540) can use it.
 */
export const NATURAL_W = 1240;
export const NATURAL_H = 760;
